import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user_details/user_table`,
        component: React.lazy(() => import('views/app-views/user_details/user_table')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user_details/delete_user_table`,
        component: React.lazy(() => import('views/app-views/user_details/delete_user_table')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user_details/account_band`,
        component: React.lazy(() => import('views/app-views/user_details/account_band')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user_details/add_user`,
        component: React.lazy(() => import('views/app-views/user_details/adduser')),
    },
    {
        key: 'languages',
        path: `${APP_PREFIX_PATH}/languages`,
        component: React.lazy(() => import('views/app-views/languages')),
    },
    {
        key: 'categoies',
        path: `${APP_PREFIX_PATH}/categoies`,
        component: React.lazy(() => import('views/app-views/categoies')),
    },
]